<template>
  <q-page padding>
    <div class="row col-12 justify-between align-center">
      <p class="text-h6 text-brand-1 text-weight-bolder">
        Listagem de Notas Fiscais
      </p>
    </div>
    <div
      class="row col-12 q-gutter-sm text-brand-5 text-weight-bold q-mt-md container-inputs"
    >
      <div class="row col-12 q-gutter-sm items-center">
        <div class="col-md-2 col-sm-6 col-xs-12" style="max-width: 14%">
          <div class="q-ml-sm texto-titulo-input">Unidade</div>
          <lista-unidades-select
            class="input-new-design"
            v-model="unidade.nome"
          ></lista-unidades-select>
        </div>
        <div class="col-md-2 col-sm-6 col-xs-12" style="max-width: 14%">
          <div class="q-ml-sm texto-titulo-input">Status</div>
          <q-select
            v-model="filtros.status"
            :options="optionsStatus"
            dense
            outlined
            class="select input-new-design"
            map-options
          />
        </div>
        <div class="col-md-2 col-sm-6 col-xs-12" style="max-width: 14%">
          <div class="q-ml-sm texto-titulo-input">Unid. Controle</div>
          <q-input
            v-model="filtros.unidadeControle"
            dense
            outlined
            class="input input-new-design"
          />
        </div>
        <div class="col-md-2 col-sm-6 col-xs-12" style="max-width: 14%">
          <div class="q-ml-sm texto-titulo-input">Num. Solicitação</div>
          <q-input
            v-model="filtros.solicitacaoCompra"
            dense
            outlined
            class="input input-new-design"
          />
        </div>
        <div class="col-md-2 col-sm-6 col-xs-12" style="max-width: 14%">
          <div class="q-ml-sm texto-titulo-input">Num. Pedido</div>
          <q-input
            v-model="filtros.pedidoCompra"
            dense
            outlined
            class="input input-new-design"
          />
        </div>
        <div class="col-md-2 col-sm-6 col-xs-12" style="max-width: 14%">
          <div class="q-ml-sm texto-titulo-input">Num. Vinculado</div>
          <q-input
            v-model="filtros.pedidoVinculado"
            dense
            outlined
            class="input input-new-design"
          />
        </div>
        <div class="col-md-1 flex items-center justify-center">
          <q-btn
            class="btn full-width q-mt-lg"
            label="Filtrar"
            icon="filter_alt"
            style="background-color: #304f78; border-radius: 8px; color: white"
            no-caps
            @click="listarNotas()"
          />
        </div>
      </div>
    </div>
    <div class="q-mt-xl">
      <q-table
        :columns="columns"
        :rows="listaNotas"
        :loading="loading"
        class="tabela-tamanho-fixo"
        color="primary"
        table-header-class="bg-accent text-weight-bold"
        flat
        hide-bottom
        dense
        :grid="$q.screen.lt.sm"
        hide-pagination
      >
        <template v-slot:top-left>
          <span
            style="
              font-size: 16px;
              display: block;
              margin-left: -15px;
              color: #21324a;
            "
            >Todas as Notas Importadas.</span
          >
        </template>
        <template v-slot:top-right>
          <q-input
            rounded
            outlined
            dense
            debounce="300"
            v-model="filtros.numero"
            type="text"
            class="col-md-3 col-xs-12"
            placeholder="Pesquisar"
          >
            <template v-slot:append>
              <q-icon name="search" />
            </template>
          </q-input>
        </template>
        <template v-slot:item="props">
          <div class="col-xs-12 col-sm-6 col-md-4 q-mb-md">
            <div class="row card text-grid-table text-brand-5 q-pa-sm">
              <div
                class="row col-12 justify-center items-center justify-between"
              >
                <div class="col-6">
                  <div class="row col-12 q-ml-sm q-mt-sm">
                    <span class="q-mr-sm"
                      ><strong class="q-mr-xs">ID: </strong>
                      {{ props.row.id }}</span
                    >
                    <span
                      ><strong class="q-mr-xs">Empresa: </strong>
                      {{ props.row.vendor.name }}</span
                    >
                  </div>
                  <span class="row col-12 q-ml-sm q-mt-sm"
                    ><strong class="q-mr-xs">Num. Nf: </strong>
                    {{ props.row.numero }}</span
                  >
                  <span class="row col-12 q-ml-sm q-mt-sm"
                    ><strong class="q-mr-xs">Fornecedor: </strong>
                    {{ props.row.provider?.business_name }}</span
                  >
                  <span class="row col-12 q-ml-sm q-mt-sm"
                    ><strong class="q-mr-xs">Data Emissão: </strong>
                    {{
                      props.row.data_emissao
                        .split(" ")[0]
                        .split("-")
                        .reverse()
                        .join("/")
                    }}</span
                  >
                  <span class="row col-12 q-ml-sm q-mt-sm"
                    ><strong class="q-mr-xs">Num. Produtos: </strong>
                    {{ props.row.products.length }}</span
                  >
                  <span class="row col-12 q-ml-sm q-mt-sm"
                    ><strong class="q-mr-xs">Valor: </strong>
                    {{
                      parseFloat(props.row.valor_nf).toLocaleString("pt-br", {
                        style: "currency",
                        currency: "BRL",
                      })
                    }}</span
                  >
                  <span class="row col-12 q-ml-sm q-mt-sm"
                    ><strong class="q-mr-xs">Status: </strong>
                    {{ props.row.status }}</span
                  >
                </div>
                <div class="col-6">
                  <div class="row col-12 justify-end">
                    <q-btn
                      class="q-mr-xs"
                      icon="edit"
                      color="primary"
                      round
                      @click="editarNota(props.row.id)"
                    />
                    <q-btn class="q-mr-xs" icon="done" color="positive" round />
                    <q-btn
                      icon="close"
                      color="negative"
                      round
                      @click="abrirModalCancelar(props.row.id)"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </template>
        <template v-slot:body-cell-id="props">
          <q-td class="text-brand-5 text-weight-bold" :props="props">
            {{ props.row.id }}
          </q-td>
        </template>
        <template v-slot:body-cell-empresa="props">
          <q-td class="text-brand-5 text-weight-bold" :props="props">
            {{ props.row.vendor.name }}
          </q-td>
        </template>
        <template v-slot:body-cell-numeroNf="props">
          <q-td class="text-brand-5 text-weight-bold" :props="props">
            {{ props.row.numero }}
          </q-td>
        </template>
        <template v-slot:body-cell-numeroPedidoCompras="props">
          <q-td class="text-brand-5 text-weight-bold" :props="props">
            {{ props.row.pedido_compra }}
          </q-td>
        </template>
        <template v-slot:body-cell-unidadeControle="props">
          <q-td class="text-brand-5 text-weight-bold" :props="props">
            <span>
              {{ props.row.cost_center?.code }}
              {{ props.row.cost_center?.name }}</span
            >
          </q-td>
        </template>
        <template v-slot:body-cell-dataEmissao="props">
          <q-td class="text-brand-5 text-weight-bold" :props="props">
            {{
              props.row.data_emissao
                .split(" ")[0]
                .split("-")
                .reverse()
                .join("/")
            }}
          </q-td>
        </template>
        <template v-slot:body-cell-numeroProdutos="props">
          <q-td class="text-brand-5 text-weight-bold" :props="props">
            {{ props.row.products.length }}
          </q-td>
        </template>
        <template v-slot:body-cell-valorTotal="props">
          <q-td class="text-brand-5 text-weight-bold" :props="props">
            <span v-if="props.row.valor_produtos != null">
              {{
                parseFloat(props.row.valor_nf).toLocaleString("pt-br", {
                  style: "currency",
                  currency: "BRL",
                })
              }}</span
            >
          </q-td>
        </template>
        <template v-slot:body-cell-status="props">
          <q-td class="text-brand-5 text-weight-bold" :props="props">
            {{ props.row.status }}
          </q-td>
        </template>
        <template v-slot:body-cell-fornecedor="props">
          <q-td class="text-brand-5 text-weight-bold" :props="props">
            {{ props.row.provider?.business_name }}
          </q-td>
        </template>
        <template v-slot:body-cell-numeroSolicitacaoCompras="props">
          <q-td class="text-brand-5 text-weight-bold" :props="props">
            {{ props.row.solicitacao_compra }}
          </q-td>
        </template>
        <template v-slot:body-cell-editar="props">
          <q-td :props="props">
            <q-btn
              icon="sym_o_edit"
              color="primary"
              flat
              round
              @click="editarNota(props.row.id)"
            />
          </q-td>
        </template>
        <!--<template v-slot:body-cell-finalizar="props">
          <q-td :props="props">
            <q-btn flat icon="sym_o_done_outline" color="positive" round />
          </q-td>
        </template>-->
        <template v-slot:body-cell-cancelar="props">
          <q-td :props="props">
            <q-btn
              flat
              icon="sym_o_close"
              color="negative"
              round
              @click="abrirModalCancelar(props.row.id)"
            />
          </q-td>
        </template>
      </q-table>
      <div class="row justify-start q-mt-md">
        <q-pagination
          :disable="disable"
          v-model="pagination.page"
          color="brand-5"
          active-color="secondary"
          active-text-color="white"
          :max="pagesNumber"
          :max-pages="5"
          :boundary-numbers="false"
          :direction-links="true"
          size="sm"
        />
      </div>
    </div>

    <DialogConfirmDesign
      :mensagem="modalCancelar.mensagem"
      :exibir="modalCancelar.exibir"
      :titulo="modalCancelar.titulo"
      @resultado="confirmarCancelar"
    />
  </q-page>
</template>

<script>
import { useQuasar } from "quasar";
import { onMounted, ref, watch, computed } from "vue";
import { useStore } from "vuex";
import { useRouter } from "vue-router";
import ListaUnidadesSelect from "../../../organizacional/unidade/component/ListaUnidadesSelect.vue";
import DialogConfirmDesign from "../../../../components/DialogConfirmDesign.vue";

const columns = [
  {
    name: "id",
    label: "ID",
    align: "left",
    style: "white-space: normal",
  },
  {
    name: "empresa",
    label: "Empresa",
    align: "left",
    style: "white-space: normal",
  },
  {
    name: "fornecedor",
    label: "Fornecedor",
    align: "left",
    style: "white-space: normal",
  },
  {
    name: "numeroNf",
    label: "Num. NF",
    align: "left",
    style: "white-space: normal",
  },
  {
    name: "numeroSolicitacaoCompras",
    label: "Num. Sol. Compras",
    align: "left",
    style: "white-space: normal",
  },
  {
    name: "numeroPedidoCompras",
    label: "Num. Ped. Compras",
    align: "left",
    style: "white-space: normal",
  },
  {
    name: "unidadeControle",
    label: "Unid. Controle",
    align: "left",
    style: "white-space: normal",
  },
  {
    name: "dataEmissao",
    label: "Data Emissão",
    align: "left",
    style: "white-space: normal",
  },
  {
    name: "numeroProdutos",
    label: "Num. Produtos",
    align: "left",
    style: "white-space: normal",
  },
  {
    name: "valorTotal",
    label: "Valor Total",
    align: "left",

    style: "white-space: normal",
  },
  {
    name: "status",
    label: "Status",
    align: "left",
    style: "white-space: normal",
  },
  {
    name: "editar",
    label: "Editar",
    align: "center",
    style: "white-space: normal",
  },

  {
    name: "cancelar",
    label: "Cancelar",
    align: "left",
    style: "white-space: normal",
  },
];
export default {
  components: {
    ListaUnidadesSelect,
    DialogConfirmDesign,
  },
  setup() {
    const store = useStore();
    const quasar = useQuasar();
    const router = useRouter();

    let unidade = ref({
      nome: store.state.org.unidadeData,
      id: store.state.org.unidadeData.id,
    });
    const filtros = ref({
      status: { label: "Pendente", value: "pendente" },
      pedidoCompra: "",
      solicitacaoCompra: "",
      numero: "",
      unidadeControle: "",
      pedidoVinculado: "",
    });
    const optionsStatus = [
      {
        label: "Todos",
        value: "",
      },
      {
        label: "Pendente",
        value: "pendente",
      },
      {
        label: "Finalizado",
        value: "finalizado",
      },
      {
        label: "Cancelado",
        value: "cancelado",
      },
    ];
    const pagination = ref({
      sortBy: "desc",
      descending: false,
      page: 1,
      rowsPerPage: 6,
      rowsNumber: 6,
    });
    let disable = ref(false);
    let loading = ref(false);
    const listaNotas = ref([]);

    const modalCancelar = ref({
      exibir: false,
      mensagem: "",
      titulo: "Confirmar Cancelamento",
      notaId: null,
    });

    const listarNotas = async (page = 0, rowsNumber = 6) => {
      try {
        loading.value = true;
        disable.value = true;

        const response = await store.dispatch("notaFiscal/listarNotas", {
          initial_date: "01/01/2017",
          pedido_compra: filtros.value.pedidoCompra,
          solicitacao_compra: filtros.value.solicitacaoCompra,
          status: filtros.value.status.value,
          vendor_id: unidade.value.id,
          page: page,
          per_page: rowsNumber,
          numero: filtros.value.numero,
          nf_pedido_vinculado: filtros.value.pedidoVinculado,
        });
        listaNotas.value = response.data.results.data;
        pagination.value.rowsPerPage = response.data.results.per_page;
        pagination.value.page = response.data.results.current_page;
        pagination.value.rowsNumber = response.data.results.total;
        loading.value = false;
        disable.value = false;
      } catch (error) {
        console.log(error);
      }
    };

    const abrirModalCancelar = (nf_id) => {
      modalCancelar.value.notaId = nf_id;
      modalCancelar.value.mensagem =
        "Tem certeza que deseja cancelar essa Nota Fiscal?";
      modalCancelar.value.exibir = true;
    };

    const confirmarCancelar = async (confirmado) => {
      modalCancelar.value.exibir = false;

      if (!confirmado) {
        modalCancelar.value.notaId = null;
        return;
      }

      const nf_id = modalCancelar.value.notaId;
      const nota = listaNotas.value.find((n) => n.id === nf_id);
      const isNotaFinalizada = nota?.status?.toLowerCase() === "finalizado";

      try {
        await store.dispatch("notaFiscal/cancelarNota", {
          action: "cancel",
          nf_id: nf_id,
        });
        quasar.notify({
          message: "Nota fiscal cancelada com sucesso",
          color: "positive",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
        listarNotas();
      } catch (error) {
        console.log(error);

        let errorMessage = "Erro ao cancelar nota fiscal";

        if (isNotaFinalizada) {
          if (error.response?.data?.message) {
            errorMessage = error.response.data.message;
          } else if (error.response?.data?.error) {
            errorMessage = error.response.data.error;
          } else if (error.message) {
            errorMessage = error.message;
          }
        }

        quasar.notify({
          message: errorMessage,
          color: "negative",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
      }

      modalCancelar.value.notaId = null;
    };

    const cancelarNota = async (nf_id, action) => {
      // busca a nota na lista para verificar seu status
      const nota = listaNotas.value.find((n) => n.id === nf_id);
      const isNotaFinalizada = nota?.status?.toLowerCase() === "finalizado";

      try {
        await store.dispatch("notaFiscal/cancelarNota", {
          action: action,
          nf_id: nf_id,
        });
        quasar.notify({
          message: "Nota fiscal cancelada com sucesso",
          color: "positive",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
        listarNotas();
      } catch (error) {
        console.log(error);

        let errorMessage = "Erro ao cancelar nota fiscal";

        // se a nota esta finalizada exibe a msg completa da API
        if (isNotaFinalizada) {
          if (error.response?.data?.message) {
            errorMessage = error.response.data.message;
          } else if (error.response?.data?.error) {
            errorMessage = error.response.data.error;
          } else if (error.message) {
            errorMessage = error.message;
          }
        }

        quasar.notify({
          message: errorMessage,
          color: "negative",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
      }
    };

    const editarNota = async (notaId) => {
      await router.push({ name: "nf-editar", params: { notaId: notaId } });
    };

    const backPage = async () => {
      router.back();
    };

    watch(
      () => store.state.org.unidadeData,
      () => {
        unidade.value.nome = store.state.org.unidadeData;
        unidade.value.id = store.state.org.unidadeData.id;
        listarNotas();
      }
    );

    watch(
      () => pagination.value.page,
      () => {
        listarNotas(pagination.value.page, pagination.value.rowsPerPage);
      }
    );

    watch(
      () => filtros.value.numero,
      () => {
        listarNotas();
      }
    );

    const getUnidade = () => {
      if (
        localStorage.unidade &&
        localStorage.unidade != null &&
        localStorage.unidade != "null"
      ) {
        let getunidade = localStorage.getItem("unidade");
        unidade.value.nome = JSON.parse(getunidade);
      }
    };

    onMounted(getUnidade);

    onMounted(listarNotas);

    return {
      columns,
      unidade,
      optionsStatus,
      filtros,
      listarNotas,
      pagination,
      pagesNumber: computed(() =>
        Math.ceil(pagination.value.rowsNumber / pagination.value.rowsPerPage)
      ),
      disable,
      loading,
      listaNotas,
      cancelarNota,
      abrirModalCancelar,
      confirmarCancelar,
      modalCancelar,
      editarNota,
      backPage,
    };
  },
};
</script>

<style scoped>
.align-center {
  align-items: center;
}
.texto-titulo-input {
  color: #21324a;
}
@media (max-width: 600px) {
  .texto-titulo {
    font-size: 14px;
    margin-top: 10px;
  }
  .container-inputs {
    margin: 0px 0px 0px 0px;
  }
  .texto-titulo-input {
    font-size: 12px;
    margin: 0px;
    color: #21324a;
  }
  .input {
    font-size: 12px;
  }
  .select {
    font-size: 12px;
  }
  .btn {
    margin: 8px 0px 0px 0px;
    font-size: 12px;
  }
  .texto-titulo-tabela {
    margin: 0px 0px 0px 6px;
    font-size: 12px;
  }
  .card {
    border: 1px solid #707070;
    border-radius: 5px;
  }
  .text-grid-table {
    font-size: 12px;
  }
  .btn-exportar {
    font-size: 12px;
  }
  .container-input-search {
    margin: 17px 0px;
  }
  .input-multiplo-grid {
    width: 100px;
  }
  .input-codigo-epi-grid {
    width: 70px;
    outline: none;
  }
  .input {
    font-size: 12px;
  }
}
</style>
<style>
.input-new-design .q-field--outlined .q-field__control {
  border-radius: 8px !important;
}

.input-new-design .q-field__control:before {
  border-radius: 8px !important;
}
</style>
